module.exports = __webpack_public_path__ + "media/assets/images/icon_facebook-bf6fdf6466ec3e61e9d8b811eec4b9d6.png";